import { render, staticRenderFns } from "./additional-settings.vue?vue&type=template&id=5ab8135d&scoped=true"
import script from "./additional-settings.vue?vue&type=script&lang=js"
export * from "./additional-settings.vue?vue&type=script&lang=js"
import style0 from "./additional-settings.vue?vue&type=style&index=0&id=5ab8135d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab8135d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab8135d')) {
      api.createRecord('5ab8135d', component.options)
    } else {
      api.reload('5ab8135d', component.options)
    }
    module.hot.accept("./additional-settings.vue?vue&type=template&id=5ab8135d&scoped=true", function () {
      api.rerender('5ab8135d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-block-form/components/additional-settings.vue"
export default component.exports